import { MachineStatusOrder } from "core/enums";

export const SORT_TYPES = {
  dateTimeSortType,
  orderSortType,
  stringSortType,
  combinedStringSortType,
  statusSortType,
  numericalSortType,
  categoricalSortType,
  siteOverviewStatusSortType,
  siteOverviewMachineSortType
};

export function defaultSortType(rowA, rowB, id) {
  if (rowA.original[id] < rowB.original[id]) return -1;
  if (rowB.original[id] < rowA.original[id]) return 1;
  return 0;
}

export function orderSortType(rowA, rowB, id) {
  if (rowA.original[id].order < rowB.original[id].order) return -1;
  if (rowB.original[id].order < rowA.original[id].order) return 1;
  return 0;
}

// Ideally we would also get the order of machine statuses from the api call,
// this is a work around for now for DDT data.
export function statusSortType(rowA, rowB) {
  const rowAStatus = MachineStatusOrder[rowA.original["status"]];
  const rowBStatus = MachineStatusOrder[rowB.original["status"]];

  if (rowAStatus < rowBStatus) return -1;
  if (rowBStatus < rowAStatus) return 1;
  return 0;
}

export function siteOverviewStatusSortType(rowA, rowB, id) {
  const rowAStatus = MachineStatusOrder[rowA.original[id]];
  const rowBStatus = MachineStatusOrder[rowB.original[id]];

  if (rowAStatus < rowBStatus) return -1;
  if (rowBStatus < rowAStatus) return 1;
  return 0;
}

export function stringSortType(rowA, rowB, id, desc) {
  const valueA = rowA.original[id];
  const valueB = rowB.original[id];

  if (valueA === null || valueA === undefined) return desc ? -1 : 1;

  if (valueB === null || valueB === undefined) return desc ? 1 : -1;

  return valueA.toString().localeCompare(valueB);
}

export function siteOverviewMachineSortType(rowA, rowB, _id, desc) {
  return stringSortType(rowA, rowB, "name", desc);
}

export function numericalSortType(rowA, rowB, id, desc) {
  const valueA = rowA.original[id];
  const valueB = rowB.original[id];

  if (valueA === null || valueA === undefined) return desc ? -1 : 1;

  if (valueB === null || valueB === undefined) return desc ? 1 : -1;

  return valueA - valueB;
}

export function dateTimeSortType(rowA, rowB, id, desc) {
  const valueA = rowA.original[id];
  const valueB = rowB.original[id];

  if (valueA === null || valueA === undefined) return desc ? -1 : 1;

  if (valueB === null || valueB === undefined) return desc ? 1 : -1;

  return new Date(rowB.original[id]) - new Date(rowA.original[id]);
}

export function categoricalSortType(rowA, rowB, id, desc) {
  return stringSortType(rowA, rowB, id, desc);
}

export function combinedStringSortType(rowA, rowB, id) {
  const rowAFirstValue = rowA.values[id][0];
  const rowASecondValue = rowA.values[id][1];

  const rowBFirstValue = rowB.values[id][0];
  const rowBSecondValue = rowB.values[id][1];

  if (rowAFirstValue === rowBFirstValue)
    return rowBSecondValue.localeCompare(rowASecondValue);

  return rowBFirstValue.localeCompare(rowAFirstValue);
}
